module.exports = __webpack_public_path__ + "assets/img/AA7-AA8.a7d20fe2.png";